import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="notfound-container">
            <h1>404</h1>
            <p>Упс! Страница не найдена.</p>
            <button onClick={() => navigate('/')}>На главную</button>
        </div>
    );
};

export default NotFound;
